const reportSettingsModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  templateUrl: '/modules/users/account-list/report-settings-modal/report-settings-modal.html',
  controller: 'ReportSettingsModalController',
};

angular
  .module('users.module')
  .component('reportSettingsModal', reportSettingsModal);
